<template>
  <div>
    <v-dialog
      v-model="dialogDetail"
      persistent
      max-width="600px"
      class="container1"
      scrollable
      :key="keyComponent"
    >
      <v-card :height="innerHeight" class="overflow-auto">
        <div class="d-flex justify-center pa-2" style="position: relative">
          <div style="max-height: 240px">
            <img
              :src="itemImage"
              style="
                max-width: 100%;
                max-height: 240px;
                width: auto;
                height: auto;
                border-radius: 10px;
                object-fit: contain;
                display: block;
                margin: 0 auto;
              "
              @error="onImageError($event, null, '')"
            />
          </div>

          <v-btn
            fab
            x-small
            style="z-index: 9999; position: absolute; top: 8px; right: 8px"
            class="ma-1 close-button"
            @click="$emit('close')"
            ><v-icon small :color="site.color">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-title>
          <p class="text-subtitle-1 mb-0" v-snip="{ lines: 2 }">
            {{ item.name }}
          </p></v-card-title
        >

        <v-divider style="opacity: 1; color: black" class="ma-3"></v-divider>

        <v-card-text>
          <v-col cols="12" class="pa-0">
            <v-list-item class="pa-0">
              <v-list-item-content>
                <v-col cols="12" class="text-start pa-0 d-flex justify-start">
                  <v-chip class="text-start" :color="site.color" dark small>
                    {{ category(item.category) }}
                  </v-chip>
                  <v-spacer></v-spacer>
                  <v-chip
                    v-if="item.is_top_ranking"
                    class="text-center"
                    :color="site.color"
                    small
                    outlined
                    @click="goToTopRanking"
                  >
                    {{ $t("textTopRanking") }}
                    <v-icon small> mdi-chevron-right </v-icon>
                  </v-chip>
                </v-col>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="pa-0">
              <v-list-item-avatar>
                <v-icon :color="site.color">mdi-calendar-clock</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title style="font-size: 10px">{{
                  $t("activityExpireDate")
                }}</v-list-item-title>

                <v-list-item-subtitle>{{
                  item.end_date | formatDate
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item class="pa-0" v-if="item.use_reward == false">
              <v-list-item-avatar
                size="30"
                class="ml-1 mr-6"
                style="padding-left: 2px"
              >
                <PointSymbol
                  v-if="Array.isArray(item.point) && item.point.length > 0"
                  :type="item.point[0].point_type_type"
                  :symbol="item.point[0].point_type_symbol"
                  :color="item.point[0].point_type_color"
                  :is_display="true"
                  :outlined_box="false"
                  :size="30"
                />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="font-size: 10px">{{
                  $t("collectCoin")
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  showPoint(item)
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="pa-0" v-else>
              <v-list-item-avatar
                size="30"
                class="ml-1 mr-6"
                style="padding-left: 2px"
              >
                <v-icon :color="site.color">mdi-gift</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title style="font-size: 10px">
                  {{ $t("missionReward") }}</v-list-item-title
                >
                <v-list-item-subtitle>
                  {{ getRewardName(item) }}</v-list-item-subtitle
                >
              </v-list-item-content>
            </v-list-item>
          </v-col>

          <p class="text-subtitle-2 mb-0 font-weight-bold">
            {{ $t("detail") }}
          </p>

          <div
            class="ql-editor"
            v-html="formatHtmlDetail(item.detail)"
            style="margin-top: 16px; height: fit-content"
          ></div>

          <questTrackingData
            v-if="item.mission_type == 'quest-tracking'"
            :key="questTrackingDataKey"
            :questTrackingData="questTrackingData"
            :site="site"
            :conditionSpecial="conditionSpecial"
          ></questTrackingData>
        </v-card-text>

        <v-card-actions v-if="initial_check_allow_play">
          <v-list-item class="grow" v-if="typeActivity == 'active'">
            <v-row align="center" justify="center">
              <v-btn
                block
                :color="site.color"
                class="rounded-lg white--text text-capitalize"
                style="min-width: 70%"
                @click="redirectTo(item)"
              >
                {{ $t("activityJoin") }}
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
        <v-card-actions v-if="!initial_check_allow_play">
          <v-list-item class="grow" v-if="typeActivity == 'active'">
            <v-row align="center" justify="center">
              <v-btn
                block
                :color="site.color"
                class="rounded-lg white--text text-capitalize"
                style="min-width: 70%"
                @click="redirectTo(item)"
              >
                {{ $t("viewResultActivity") }}
              </v-btn>
            </v-row>
          </v-list-item>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogScan
      v-if="dialogScan"
      :dialogScan="dialogScan"
      :confirmExternal="confirmExternal"
      :refMissionId="missionId"
      @closeDialogScan="dialogScan = false"
      @scanText="handleScanQR"
      @onScanSuccess="handleScanSuccess"
    />
  </div>
</template>

<script>
import moment from "moment";
import Axios from "@/config/customer-service";
import questTrackingData from "../../views/Customer/Mission/component/questTrackingData.vue";
import DialogScan from "@/components/activity/dialogScan.vue";
import PointSymbol from "../point/point-symbol.vue";
import { formatHtmlDetailDefault } from "../../config/general-function.js";

export default {
  props: ["item", "dialogDetail", "keyComponent", "site", "typeActivity"],
  components: {
    questTrackingData,
    DialogScan,
    PointSymbol,
  },
  data() {
    return {
      dataItem: {},
      questTrackingData: [],
      conditionSpecial: {},
      questTrackingDataKey: 0,
      dialogScan: false,
      qr_code: "",
      missionId: null,
      confirmExternal: false,
    };
  },

  watch: {
    item: {
      handler() {
        if (this.item.employee_missions_id) {
          this.getMyMissionDetail(this.item.employee_missions_id);
        } else {
          this.getMissionDetail(this.item.id);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    goToTopRanking() {
      this.$router.push({
        name: "top-ranking",
        params: { id: this.item.id },
      });
    },
    getMissionDetail(mission_id) {
      Axios.get("mission/getMission", {
        params: {
          mission_id: mission_id,
          view_in_period_remind_date: true,
          view_limit_reached: true,
        },
      })
        .then(({ data }) => {
          this.dataItem = data.data;
          this.missionId = this.dataItem.id;
          if (
            ["survey", "exam", "multi-upload", "survey-summary"].includes(
              this.dataItem.type
            )
          ) {
            this.confirmExternal = true;
          } else {
            this.confirmExternal = false;
          }
          this.questTrackingData = data.data.quest_tracking_data;
          this.conditionSpecial = data.data.condition_special;
          this.questTrackingDataKey++;
          this.$store.commit("login/SET_URL_REDIRECT", { urlRedirect: "" });
        })
        .catch((err) => {
          console.log("err :>>", err);
        });
    },
    getMyMissionDetail(employee_mission_id) {
      Axios.get("mission/getMyMission", {
        params: {
          employee_mission_id: employee_mission_id,
          view_in_period_remind_date: true,
          view_limit_reached: true,
        },
      })
        .then(({ data }) => {
          this.dataItem = data.data;
          this.missionId = this.dataItem.id;
          if (
            ["survey", "exam", "multi-upload", "survey-summary"].includes(
              this.dataItem.type
            )
          ) {
            this.confirmExternal = true;
          } else {
            this.confirmExternal = false;
          }
          this.questTrackingData = data.data.quest_tracking_data;
          this.conditionSpecial = data.data.condition_special;
          this.questTrackingDataKey++;
          this.$store.commit("login/SET_URL_REDIRECT", { urlRedirect: "" });
        })
        .catch((err) => {
          console.log("err :>> ", err);
        });
    },
    redirectTo(item) {
      if (!this.initial_check_allow_play) {
        if (item.employee_missions_id) {
          this.$router.push({
            name: "my-mission-detail",
            params: {
              status: this.status,
              id: item.employee_missions_id,
            },
            query: {
              from: "all",
            },
          });
        } else {
          this.$router.push({
            name: "mission-detail",
            params: { id: item.id, status: "all" },
          });
        }
        return;
      }

      this.qr_code = "";
      item.mission_type = item.mission_type || item.type;
      if (
        item.mission_type === "survey" ||
        item.mission_type === "exam" ||
        item.mission_type === "multi-upload" ||
        item.mission_type === "survey-summary"
      ) {
        if (this.dataItem.require_qr) {
          this.dialogScan = true;
        } else {
          this.confirmSurvey();
        }
      } else if (item.mission_type === "upload") {
        this.confirmUpload();
      } else if (item.mission_type === "lucky draw") {
        this.confirmLuckyDraw();
      } else if (item.mission_type === "check-in") {
        this.confirmCheckin();
      } else if (item.mission_type === "kahoot") {
        this.confirmKahoot();
      } else if (item.mission_type === "quest-tracking") {
        if (this.dataItem.require_qr) {
          this.dialogScan = true;
        } else {
          this.confirmQuestTracking();
        }
      }
    },
    handleScanQR(param) {
      this.qr_code = param;
      this.dialogScan = false;
      this.confirmSurvey();
    },
    handleScanSuccess(param) {
      const mission_type = param.mission_type;
      const employee_mission = param.employee_mission;
      if (mission_type == "quest-tracking") {
        this.$router.push({
          name: "my-mission-detail",
          params: { id: employee_mission.id },
        });
        return;
      }
    },

    // ========== ========== ========== ==========
    confirmQuestTracking() {
      if (this.item.employee_missions_id) {
        this.$router.push({
          name: "my-mission-detail",
          params: { id: this.item.employee_missions_id },
          query: { from: "all" },
        });
        return;
      }

      Axios.post("mission/takeMission", {
        mission_id: this.dataItem.id,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });

            this.$router.push({
              name: "my-mission-detail",
              params: { id: data.data.employee_mission_id },
              query: { from: "all" },
            });
          }
        })
        .catch(() => {
          this.$router.push({
            name: "mission",
          });
        });
    },
    confirmSurvey() {
      if (this.item.employee_missions_id) {
        this.$router.push({
          name: "mission-survey",
          params: { id: this.item.employee_missions_id },
        });
        return;
      }
      Axios.post("mission/takeMission", {
        mission_id: this.item.id,
        qr_code: this.qr_code,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-survey",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-survey",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err?.response?.data?.message || this.$t("errDataNotFound"),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    confirmUpload() {
      if (this.item.employee_missions_id) {
        this.$router.push({
          name: "mission-upload",
          params: { id: this.item.employee_missions_id },
        });
        return;
      }
      Axios.post("mission/takeMission", {
        mission_id: this.item.id,
        qr_code: this.qr_code,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-upload",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-upload",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err?.response?.data?.message || this.$t("errDataNotFound"),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    confirmLuckyDraw() {
      if (this.item.employee_missions_id) {
        this.$router.push({
          name: "mission-lucky-draw",
          params: { id: this.item.employee_missions_id },
        });
        return;
      }
      Axios.post("mission/takeMission", {
        mission_id: this.item.id,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-lucky-draw",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-lucky-draw",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err?.response?.data?.message || this.$t("errDataNotFound"),
            showConfirmButton: false,
            timer: 3000,
          });
          this.$emit("close");
        });
    },
    confirmCheckin() {
      if (this.item.employee_missions_id) {
        this.$router.push({
          name: "mission-checkin",
          params: { id: this.item.employee_missions_id },
        });
        return;
      }
      Axios.post("mission/takeMission", {
        mission_id: this.item.id,
        qr_code: this.qr_code,
      })
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$router.push({
              name: "mission-checkin",
              params: { id: data.data.employee_mission_id },
            });
          } else if (data.status == "join") {
            this.$router.push({
              name: "mission-checkin",
              params: { id: data.data.id },
            });
          } else {
            this.$swal.fire({
              icon: "error",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err?.response?.data?.message || this.$t("errDataNotFound"),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    confirmKahoot() {
      Axios.post("mission/takeMission", {
        mission_id: this.item.id,
        qr_code: this.qr_code,
      })
        .then(({ data }) => {
          if (data.status == "success" && this.dataItem.type != "kahoot") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });

            this.employee_mission_id = data.data.employee_mission_id;
            setTimeout(() => {
              if (this.dataItem.link_kahoot != null) {
                return window.open(this.dataItem.link_kahoot, "_blank");
              } else {
                return window.open(this.kahoot_link, "_blank");
              }
            }, 2000);
          } else if (
            data.status == "success" &&
            this.dataItem.kahoot_type != "game"
          ) {
            this.$swal.fire({
              icon: "success",
              title: this.$t("welcomeActivity"),
              showConfirmButton: false,
              timer: 2000,
            });

            this.employee_mission_id = data.data.employee_mission_id;
            setTimeout(() => {
              if (this.dataItem.link_kahoot != null) {
                return window.open(this.dataItem.link_kahoot, "_blank");
              } else {
                return window.open(this.kahoot_link, "_blank");
              }
            }, 2000);
          } else {
            this.$swal.fire({
              icon: "success",
              text: data.message,
              showConfirmButton: false,
              timer: 3000,
            });

            this.employee_mission_id = data.data.employee_mission_id;
            setTimeout(() => {
              if (this.dataItem.link_kahoot != null) {
                return window.open(this.dataItem.link_kahoot, "_blank");
              } else {
                return window.open(this.kahoot_link, "_blank");
              }
            }, 2000);
          }
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            text: err?.response?.data?.message || this.$t("errDataNotFound"),
            showConfirmButton: false,
            timer: 3000,
          });
        });
    },
    // ========== ========== ========== ==========

    formatHtmlDetail(value) {
      return formatHtmlDetailDefault(value);
    },
    showPoint(pararm) {
      let pointDetail = {
        point: 0,
        point_type_name: "",
      };
      if (Array.isArray(pararm.point) && pararm.point.length > 0) {
        pointDetail = pararm.point[0];
      }
      if (pararm.use_reward == true) {
        return `${this.$t("rewardPrize")}`;
      } else if (pointDetail.point == 0 || pararm.type == "check-in") {
        return `${this.$t("conditionCoin")}`;
      } else if (Array.isArray(pararm.point) && pararm.point.length > 1) {
        // return `${this.$t("textNumberMore", { number: pararm.point.length })}`;
        return `+${pararm.point.length}`;
      } else {
        const formattedPoint = this.$options.filters.commaPoint(
          pointDetail.point
        );
        return `${formattedPoint} ${pointDetail.point_type_name}`;
      }
    },
    category(value) {
      if (!value) return this.$t("textNotSpecified");
      return value;
    },
    getRewardName(data) {
      let rewards = data.mission_rewards;
      if (rewards == undefined) {
        return "-";
      } else if (rewards.length == 0) return "-";
      else return rewards.map((reward) => reward.name).join(", ");
    },
  },
  computed: {
    innerHeight() {
      const height = window.innerHeight;
      const _height = (height * 90) / 100;
      return _height;
    },
    itemImage() {
      return this.item.image_path || this.item.image_url;
    },
    initial_check_allow_play() {
      return (
        !this.item.limit_reached &&
        this.item.quest_tracking_allow_play &&
        this.item.has_permission_play &&
        !this.item.in_period_remind_date &&
        this.item.in_period_show_time_selected
      );
    },
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
